import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import useWhen from "../hooks/useWhen";
import { END_OF_PILOT_25_ARGS } from "../consts/feature-config";

// Blocks the trade-in flow once the 2025 pilot has ended and sends the
// user to the end-of-pilot landing page instead
export const EndOfPilotRoute = ({ children }) => {
  const { t } = useTranslation();
  const pilotEnded = useWhen(END_OF_PILOT_25_ARGS);

  if (pilotEnded) {
    // Keep the query string so ?simulateEnv testing carries through the redirect
    return (
      <Navigate to={`${t("urls.landing")}${window.location.search}`} replace />
    );
  }

  return children;
};
